// extracted by mini-css-extract-plugin
export default {"loadingPanelContainer":"_loading-panel_loadingPanelContainer__pDGZC"};